interface StatusBadgeProps {
  status: string;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusConfig = {
    pending: { label: 'Pendiente', color: 'bg-yellow-100 text-yellow-800' },
    processing: { label: 'Procesando', color: 'bg-blue-100 text-blue-800' },
    resolved: { label: 'Resuelto', color: 'bg-green-100 text-green-800' },
    failed: { label: 'Fallido', color: 'bg-red-100 text-red-800' },
    ignored: { label: 'Ignorado', color: 'bg-gray-100 text-gray-800' },
  };

  const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.pending;

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${config.color}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
